export const PUZZLE_HUMAN_PLAYER_INDEX = 0;

// El turno guardado nunca redefine la propiedad: el usuario siempre conserva
// el primer jugador (bloques azules) y los demas slots pertenecen a bots.
export const resolvePuzzleHumanPlayerIndex = () => PUZZLE_HUMAN_PLAYER_INDEX;
